import { fetchAction, fetchApi, fetchPostApi, fetchPostFormData } from "../../../helpers/fetch";

export const fetchDeactivateUser = (user_id) => fetchPostApi(`/admin/users/deactivate/${user_id}`, {})
export const fetchUpdateUser = (user, user_id) => fetchPostApi(`/admin/users/${user_id}`, user)
export const fetchUpdateProfile = (user, user_id) => fetchPostApi(`/api/profile/${user_id}`, user)
export const fetchUpdateProfilePic = (obj, user_id) => fetchPostFormData(`/api/profile/profile-picture/${user_id}`, obj)

export const fetchSendInvite = (obj) => fetchPostApi('/api/profile/invitations/send-invite', obj)
export const fetchVerifyInvite = (token, sender_id) => fetchApi(sender_id?`/api/invitations/verify?token=${token}&code=${sender_id}`:`/api/invitations/verify?token=${token}`)
export const fetchVerifyCommLink = (sender_id) => fetchApi(`/api/invitations/verify-code?code=${sender_id}`)

export const fetchCheckEmail = (email) => fetchPostApi(`/api/profile/check-email`, { email })
export const fetchCheckPassword = ( password) => fetchPostApi(`/api/profile/check-password`, { password })
export const changeOnboardingVersion = ()=>fetchPostApi('/api/profile/on-boarding-version')

export const fetchReportUser = (user_id, reason) =>
    fetchPostApi(`/api/report/users/${user_id}`, { user_id, reason });


export const fetchUsers = () =>
    fetchAction(`/admin/users`, [
        'SET_USERS_REQUEST',
        'SET_USERS_SUCCESS',
        'SET_USERS_FAILURE'
    ])

export const updateUserInList = (list_users, user, id) => {
    const index = (list_users || []).findIndex(el => el.user_id === id)
    if (index > -1)
        return {
            type: 'UPDATE_USER_LIST',
            payload: {
                index, user
            }
        }
    else return null
}

// Search users functionality  
export const fetchSearchUsers = (query) => fetchApi(`/api/profile/search?query=${encodeURIComponent(query)}`);

export const searchUsers = (query) => {
    return async (dispatch) => {
        dispatch({ type: 'SEARCH_PEOPLE_REQUEST' });

        try {
            const response = await fetchSearchUsers(query);

            if (response.success) {
                dispatch({
                    type: 'SEARCH_PEOPLE_SUCCESS',
                    payload: response.data
                });
                return { success: true, data: response.data };
            } else {
                dispatch({
                    type: 'SEARCH_PEOPLE_FAILURE',
                    payload: response.message || 'Failed to search users'
                });
                return { success: false, message: response.message };
            }
        } catch (error) {
            console.error('Search users error:', error);
            dispatch({
                type: 'SEARCH_PEOPLE_FAILURE',
                payload: 'Failed to search users'
            });
            return { success: false, message: 'Failed to search users' };
        }
    };
};

export const updateReportOnUser = (creation_id) => ({
    type: 'UPDATE_REPORTED_USER',
    payload: { creation_id }
})

// Fetch user details for contribution page (public endpoint, works for logged-out users)
// This endpoint accepts either username or user_id
export const fetchUserForContribution = (usernameOrId) => {
    return fetchApi(`/api/profile/contribution/${encodeURIComponent(usernameOrId)}`);
}
